import * as React from 'react';

/**
 * Shared SVG icon sprite (ported from docs/design/specimen/sprite.js) + an <Ic>
 * helper. Mount <IconSprite/> once near the app root; then <Ic name="tree"/>
 * resolves via <use href="#i-tree"/>. Icons inherit currentColor.
 */
export function IconSprite() {
  return (
    <svg style={{ display: 'none' }} aria-hidden="true" dangerouslySetInnerHTML={{ __html: `
  <symbol id="m-check" viewBox="0 0 20 20"><path d="M3.5 10.5l4 4.5L16.5 5"/></symbol>
  <symbol id="i-tree" viewBox="0 0 20 20"><path d="M4 5h12"/><path d="M8 10h8"/><path d="M8 15h8"/><path d="M4 5v11"/><path d="M4 10h4"/><path d="M4 15h4"/></symbol>
  <symbol id="i-grid" viewBox="0 0 20 20"><rect x="4" y="4" width="5.5" height="5.5" rx="1.3"/><rect x="10.5" y="4" width="5.5" height="5.5" rx="1.3"/><rect x="4" y="10.5" width="5.5" height="5.5" rx="1.3"/><rect x="10.5" y="10.5" width="5.5" height="5.5" rx="1.3"/></symbol>
  <symbol id="i-nodes" viewBox="0 0 20 20"><circle cx="5" cy="6" r="2"/><circle cx="15" cy="6" r="2"/><circle cx="10" cy="15" r="2"/><path d="M6.7 7.4 9 13"/><path d="M13.3 7.4 11 13"/><path d="M7 6h6"/></symbol>
  <symbol id="i-import" viewBox="0 0 20 20"><path d="M13 3H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6z"/><path d="M12 3v3h3"/><path d="M10 9.5v4.5"/><path d="M8 12l2 2 2-2"/></symbol>
  <symbol id="i-gear" viewBox="0 0 20 20"><circle cx="10" cy="10" r="2.6"/><path d="M10 3.2v2.2M10 14.6v2.2M3.2 10h2.2M14.6 10h2.2M5.1 5.1l1.6 1.6M13.3 13.3l1.6 1.6M14.9 5.1l-1.6 1.6M6.7 13.3l-1.6 1.6"/></symbol>
  <symbol id="i-search" viewBox="0 0 20 20"><circle cx="9" cy="9" r="5"/><path d="M16 16l-3.2-3.2"/></symbol>
  <symbol id="i-chev" viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></symbol>
  <symbol id="i-folder" viewBox="0 0 20 20"><path d="M3 6a1 1 0 0 1 1-1h3.5l1.8 2H16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/></symbol>
  <symbol id="i-doc" viewBox="0 0 20 20"><path d="M6 3h5l3 3v11H6z"/><path d="M11 3v3h3"/><path d="M8 10h4M8 13h4"/></symbol>
  <symbol id="i-check" viewBox="0 0 20 20"><circle cx="10" cy="10" r="7"/><path d="M6.8 10.3l2.2 2.2 4.2-4.7"/></symbol>
  <symbol id="i-link" viewBox="0 0 20 20"><path d="M8.5 11.5a3 3 0 0 1 0-4l1.5-1.5a3 3 0 0 1 4.2 4.2l-1 1"/><path d="M11.5 8.5a3 3 0 0 1 0 4l-1.5 1.5a3 3 0 0 1-4.2-4.2l1-1"/></symbol>
  <symbol id="i-clock" viewBox="0 0 20 20"><circle cx="10" cy="10" r="7"/><path d="M10 6v4.2l2.8 1.8"/></symbol>
  <symbol id="i-spark" viewBox="0 0 20 20"><path d="M10 3l1.6 4.8L16.5 9.4l-4.9 1.6L10 16l-1.6-5L3.5 9.4l4.9-1.6z"/></symbol>
  <symbol id="i-send" viewBox="0 0 20 20"><path d="M10 16V5"/><path d="M5.5 9.5L10 5l4.5 4.5"/></symbol>
  <symbol id="i-refresh" viewBox="0 0 20 20"><path d="M15.5 7a6 6 0 1 0 1.2 4"/><path d="M16.5 3.8V7h-3.2"/></symbol>
  <symbol id="i-plus" viewBox="0 0 20 20"><path d="M10 5v10M5 10h10"/></symbol>
  <symbol id="i-filter" viewBox="0 0 20 20"><path d="M4 5.5h12l-4.6 5.6v4l-2.8 1v-5z"/></symbol>
  <symbol id="i-dots" viewBox="0 0 20 20"><circle cx="5" cy="10" r="1.2"/><circle cx="10" cy="10" r="1.2"/><circle cx="15" cy="10" r="1.2"/></symbol>
  <symbol id="i-users" viewBox="0 0 20 20"><circle cx="8" cy="7.5" r="2.6"/><path d="M3.6 16a4.4 4.4 0 0 1 8.8 0"/><path d="M13.5 5.4a2.6 2.6 0 0 1 0 5"/><path d="M14.4 16a4.4 4.4 0 0 0-2-3.7"/></symbol>
  <symbol id="i-shield" viewBox="0 0 20 20"><path d="M10 3l6 2v4.5c0 4-3 6.2-6 7.2-3-1-6-3.2-6-7.2V5z"/></symbol>
  <symbol id="i-bell" viewBox="0 0 20 20"><path d="M6 9a4 4 0 0 1 8 0c0 3.6 1.4 4.6 1.4 4.6H4.6S6 12.6 6 9z"/><path d="M8.4 16.4a1.8 1.8 0 0 0 3.2 0"/></symbol>
  <symbol id="i-moon" viewBox="0 0 20 20"><path d="M15.5 11.2a5.6 5.6 0 1 1-6.7-7 4.6 4.6 0 0 0 6.7 7z"/></symbol>
  <symbol id="i-sun" viewBox="0 0 20 20"><circle cx="10" cy="10" r="3.2"/><path d="M10 3v2M10 15v2M3 10h2M15 10h2M5.1 5.1l1.4 1.4M13.5 13.5l1.4 1.4M14.9 5.1l-1.4 1.4M6.5 13.5l-1.4 1.4"/></symbol>
  <symbol id="i-help" viewBox="0 0 20 20"><circle cx="10" cy="10" r="7"/><path d="M8.3 8a1.8 1.8 0 0 1 3.4.6c0 1.2-1.7 1.6-1.7 2.7"/><circle cx="10" cy="14" r=".4"/></symbol>
  <symbol id="i-decompose" viewBox="0 0 20 20"><circle cx="5" cy="5" r="1.6"/><circle cx="5" cy="15" r="1.6"/><circle cx="15" cy="10" r="1.6"/><path d="M5 6.6v6.8"/><path d="M5 10h6a2.5 2.5 0 0 0 2.5-2.5V8.8"/><path d="M11 10h2.5"/></symbol>
  <symbol id="i-arrow" viewBox="0 0 20 20"><path d="M4 10h11"/><path d="M11 6l4 4-4 4"/></symbol>
  <symbol id="i-menu" viewBox="0 0 20 20"><path d="M4 6h12M4 10h12M4 14h12"/></symbol>
  <symbol id="i-panel" viewBox="0 0 20 20"><rect x="3.5" y="4.5" width="13" height="11" rx="1.6"/><path d="M8 4.5v11"/></symbol>
  <symbol id="i-panelr" viewBox="0 0 20 20"><rect x="3.5" y="4.5" width="13" height="11" rx="1.6"/><path d="M12 4.5v11"/></symbol>
  <symbol id="i-mail" viewBox="0 0 20 20"><rect x="3" y="5" width="14" height="10" rx="1.6"/><path d="M3.5 6l6.5 5 6.5-5"/></symbol>
  <symbol id="i-key" viewBox="0 0 20 20"><circle cx="7" cy="9" r="3"/><path d="M9.5 10.5L16 17M14 15l1.5-1.5M12.5 13.5L14 12"/></symbol>
  <symbol id="i-archive" viewBox="0 0 20 20"><rect x="3" y="4" width="14" height="3.5" rx="1"/><path d="M4.5 7.5V15a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V7.5"/><path d="M8 11h4"/></symbol>
  <symbol id="i-copy" viewBox="0 0 20 20"><rect x="7" y="7" width="9" height="9" rx="1.4"/><path d="M13 7V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2"/></symbol>
  <symbol id="i-comment" viewBox="0 0 20 20"><path d="M3.5 5.5a1.5 1.5 0 0 1 1.5-1.5h10a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5H9l-3.2 2.8a.5.5 0 0 1-.8-.38V13H5a1.5 1.5 0 0 1-1.5-1.5z"/></symbol>
    ` }} />
  );
}

/**
 * RMDV brand mark — the canonical "V carrying four verification tickboxes" logo
 * (same art as public/favicon.svg). Self-contained tile (blue square + white V)
 * so it reads on light, dark and brand backgrounds. The gradient id is scoped
 * per-instance to avoid collisions when rendered more than once.
 *
 * `style` carries no default, so an unannotated destructure infers it as a
 * REQUIRED property and every `<BrandLogo size={n}/>` call site reports TS2741
 * (#968 Phase B). The annotation below states what the call sites already
 * assume; it changes no behaviour.
 *
 * @param {object} props
 * @param {number} [props.size]
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style] Merged over the built-in layout style.
 */
export function BrandLogo({ size = 24, className = '', style }) {
  const gid = `rmdvg-${React.useId().replace(/:/g, '')}`;
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" className={className}
      style={{ display: 'block', flexShrink: 0, ...style }} role="img" aria-label="RMDV">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2B86F2" /><stop offset="1" stopColor="#0A4FC0" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="108" height="108" rx="27" fill={`url(#${gid})`} />
      <g transform="translate(60,58) scale(0.82) translate(-60,-52)">
        <path d="M2 8 L60 96 L118 8" fill="none" stroke="#fff" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" opacity=".92" />
        <g strokeLinecap="round" strokeLinejoin="round">
          <rect x="22.4" y="11" width="18" height="18" rx="4" fill="#fff" /><path d="M26.4 20 29.8 23.3 36.4 15.8" fill="none" stroke="#0A6BEB" strokeWidth="3" />
          <rect x="79.6" y="11" width="18" height="18" rx="4" fill="#fff" /><path d="M83.6 20 87.0 23.3 93.6 15.8" fill="none" stroke="#0A6BEB" strokeWidth="3" />
          <rect x="38.2" y="35" width="18" height="18" rx="4" fill="#fff" /><path d="M42.2 44 45.6 47.3 52.2 39.8" fill="none" stroke="#0A6BEB" strokeWidth="3" />
          <rect x="63.8" y="35" width="18" height="18" rx="4" fill="#fff" /><path d="M67.8 44 71.2 47.3 77.8 39.8" fill="none" stroke="#0A6BEB" strokeWidth="3" />
        </g>
      </g>
    </svg>
  );
}

/** Inline icon. <Ic name="tree" sm /> -> 16px (or 14px with sm), inherits color.
 *
 * The outer <svg> carries an explicit viewBox + width/height attributes (every
 * sprite symbol is authored in a 0 0 20 20 box). Without an intrinsic geometry
 * on the referencing <svg>, mobile WebKit can fail to PAINT a `<use>` of a
 * `display:none` sprite symbol until an unrelated reflow — the bug behind the
 * invisible notification bell (#359). CSS still governs the rendered size
 * (`.ic{width/height}` wins over the presentation attributes); the attributes
 * only guarantee a first paint.
 *
 * `style` carries no default, so an unannotated destructure infers it as a
 * REQUIRED property. `<Ic>` is the app's icon primitive and almost no call site
 * passes `style`, which is why one missing `?` produced 59 of the 277 errors
 * #968 Phase B started from — the single largest group in the whole count.
 *
 * @param {object} props
 * @param {string} props.name Sprite symbol id without the `i-` prefix.
 * @param {boolean} [props.sm] Render at 14px instead of 16px.
 * @param {string} [props.className] Appended after `ic`/`ic-sm`.
 * @param {React.CSSProperties} [props.style]
 */
export function Ic({ name, sm = false, className = '', style }) {
  return (
    <svg
      className={`ic${sm ? ' ic-sm' : ''}${className ? ' ' + className : ''}`}
      viewBox="0 0 20 20" width={sm ? 14 : 16} height={sm ? 14 : 16}
      style={style} aria-hidden="true"
    >
      <use href={`#i-${name}`} />
    </svg>
  );
}

export default Ic;
